var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVineLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.4392 7.72611e-06C39.4392 7.72611e-06 38.8632 1.4873 38.536 3.53478L38.5248 3.5908C38.4996 3.78967 38.4689 3.98853 38.4465 4.1958L38.4465 4.20701C38.0802 7.2124 38.371 11.1197 41.5728 13.4473C47.308 17.6179 59.0442 11.5931 59.0442 11.5931C59.0442 11.5931 57.6292 11.425 55.56 10.9656C50.3253 9.80326 40.8793 6.79506 39.4392 0.00281153L39.4392 7.72611e-06Z",
    fill: "url(#paint0_linear_10020_170267)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4493 4.2042C38.083 7.20959 38.3738 11.1169 41.5756 13.4445C47.3108 17.615 59.047 11.5902 59.047 11.5902C59.047 11.5902 57.632 11.4222 55.5628 10.9628C55.5628 10.9628 48.7006 15.7888 43.3596 13.1532C39.1512 11.0749 38.3263 5.76711 38.4493 4.20139L38.4493 4.2042Z",
    fill: "url(#paint1_linear_10020_170267)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82 18C82 15 81.4322 15 79.5 12.6602C74 6 50.1966 11.3382 33.5698 20.9565C16.9429 30.5749 24.4202 39.4651 25.4772 52.9123C26.5314 66.3596 13.495 80.1066 13.495 80.1066C13.495 80.1066 26.0309 67.9897 26.6573 56.3155C27.2836 44.6412 21.8616 40.3698 25.2004 30.9531C28.5364 21.5363 60.9317 12.0664 69.8659 12.6602C73 15 71.9788 15.1459 73.5 18C77 18 78.5 18 78.5 18L82 18Z",
    fill: "url(#paint2_linear_10020_170267)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0281 51.2934C20.6396 62.8444 4.78169 62.9677 4.78169 62.9677C4.78169 62.9677 7.10263 66.1775 10.7071 67.6704C10.7071 67.6704 10.7071 67.676 10.7127 67.676C12.8798 68.5807 15.5111 68.858 18.383 67.4436C23.9197 64.7155 25.4493 57.4694 25.8715 53.6826L25.8715 53.677C26.0309 52.2345 26.0309 51.2962 26.0309 51.2962L26.0281 51.2934Z",
    fill: "url(#paint3_linear_10020_170267)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5734 57.167L25.2004 62.8725C25.2004 62.8725 25.1696 62.9313 25.1165 63.0517C25.1165 63.0517 25.1109 63.0517 25.1109 63.0573C24.4118 64.5334 19.8566 74.4935 22.5607 78.7873C24.8285 82.3893 30.5246 82.14 32.9601 81.8459C33.6704 81.7619 34.101 81.6723 34.101 81.6723C34.101 81.6723 31.7941 82.0504 28.2847 73.5132C24.9962 65.5165 26.3832 58.0829 26.5734 57.167Z",
    fill: "url(#paint4_linear_10020_170267)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4254 68.83C21.0534 69.1129 7.56682 79.1683 -1.71263e-06 76.7959C-1.71263e-06 76.7959 4.20845 81.1849 9.58576 81.2494L9.59136 81.2494C10.5086 81.2634 11.4565 81.1513 12.4296 80.8656C19.0932 78.9218 21.4337 68.8244 21.4337 68.8244L21.4226 68.83L21.4254 68.83Z",
    fill: "url(#paint5_linear_10020_170267)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1685 31.4516L23.2961 32.2163C23.2961 32.2163 12.7428 42.9999 1.21082 42.4985C1.21082 42.4985 1.66102 42.787 2.43 43.1931C4.96626 44.5348 10.9699 47.1929 15.746 45.2658C20.469 43.3668 22.8655 36.4205 23.7547 33.1602L23.7603 33.149C24.0371 32.1099 24.1658 31.4488 24.1658 31.4488L24.1685 31.4516Z",
    fill: "url(#paint6_linear_10020_170267)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6556 16.2986C21.6854 17.0997 14.6275 21.175 11.8871 22.878C11.1433 23.3401 10.7155 23.6286 10.7155 23.6286C10.7155 23.6286 11.2999 24.9199 19.4428 25.9842C27.3815 27.0178 39.3441 18.1976 39.9537 17.7383C39.9733 17.7243 39.9845 17.7187 39.9845 17.7187C39.9845 17.7187 33.3209 15.5367 27.6556 16.2986Z",
    fill: "url(#paint7_linear_10020_170267)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.0062 19.0435C41.1534 19.276 40.0964 19.5953 38.9611 20.007C36.422 20.9202 33.4775 22.2982 31.4585 24.2252C31.1314 24.5333 30.8322 24.8611 30.5665 25.2C30.5665 25.2 30.5609 25.2056 30.5553 25.2112C29.5319 26.4828 28.9335 27.9645 29.0369 29.6731C29.5291 37.6781 39.6406 40.7115 39.9537 40.8011C39.8978 40.7367 39.4476 40.2494 38.8268 39.4455L38.8128 39.4315C36.7743 36.7762 32.9769 30.729 35.8208 25.4268C37.2944 22.6847 38.8772 21.0322 40.2613 20.0407C40.8961 19.5897 41.4861 19.2704 42.009 19.0463L42.0062 19.0435Z",
    fill: "url(#paint8_linear_10020_170267)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.2907 12.3467C57.5192 13.5651 55.4471 18.4108 54.7117 22.1472L54.7117 22.1528C54.2195 24.696 54.3453 26.7239 54.3453 26.7239C54.3453 26.7239 59.4654 21.1473 65.3544 18.6236C71.2435 16.1028 75.9972 17.9234 75.9972 17.9234C75.9972 17.9234 75.2925 16.1252 73.4525 14.5147C71.5063 12.8005 68.2878 11.2992 63.2907 12.3467Z",
    fill: "url(#paint9_linear_10020_170267)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1825 35.3533C24.1825 35.3533 24.0874 37.2916 24.3307 39.6808C24.6691 43.0503 25.6702 47.3189 28.5336 48.274C33.4271 49.9098 42.8367 52.0413 42.8367 52.0413C42.8367 52.0413 42.8367 52.0357 42.8311 52.0301C42.7864 51.7976 41.9475 48.0555 38.0634 45.1034C34.0535 42.0559 25.0438 43.3444 24.1797 35.3533L24.1825 35.3533Z",
    fill: "url(#paint10_linear_10020_170267)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.8995 17.6405C56.5013 19.2846 55.4723 20.8111 54.7145 22.1472L54.7145 22.1528C54.2223 24.696 54.3481 26.7239 54.3481 26.7239C54.3481 26.7239 59.4682 21.1473 65.3572 18.6236C71.2463 16.1028 76 17.9234 76 17.9234C76 17.9234 75.1303 16.4641 72.9408 15.3745C70.7038 14.2626 62.1666 12.61 57.8995 17.6405Z",
    fill: "url(#paint11_linear_10020_170267)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8871 22.8808C11.1433 23.3429 10.7155 23.6314 10.7155 23.6314C10.7155 23.6314 11.2999 24.9227 19.4428 25.987C27.3815 27.0206 39.3441 18.2004 39.9537 17.7411C39.333 18.1276 29.2998 24.3513 22.1412 24.9731C17.5469 25.3708 13.9508 23.9844 11.8843 22.8808L11.8871 22.8808Z",
    fill: "url(#paint12_linear_10020_170267)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.8517 24.9759C30.821 24.9955 30.7175 25.0739 30.5637 25.2C30.5637 25.2 30.5581 25.2056 30.5525 25.2112C29.5291 26.4828 28.9307 27.9645 29.0341 29.6731C29.5263 37.6781 39.6377 40.7115 39.9509 40.8011C39.895 40.7367 39.4448 40.2494 38.824 39.4455L38.81 39.4315C38.81 39.4315 32.8623 36.4149 31.0754 32.3059C29.3333 28.3006 30.779 25.144 30.8517 24.9815L30.8517 24.9759Z",
    fill: "url(#paint13_linear_10020_170267)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3307 39.6836C24.6691 43.0531 25.6702 47.3217 28.5336 48.2768C33.4271 49.9126 42.8367 52.0441 42.8367 52.0441C42.8367 52.0441 42.8367 52.0385 42.8311 52.0329C42.6913 51.7808 40.0684 47.0276 35.6166 45.1062C31.0419 43.1343 26.3385 42.8738 25.0242 40.8067C24.7474 40.3698 24.5181 40.0029 24.3307 39.6836Z",
    fill: "url(#paint14_linear_10020_170267)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1685 31.4516L23.2961 32.2163C23.2961 32.2163 12.7428 42.9998 1.21082 42.4985C1.21082 42.4985 1.66102 42.787 2.43 43.1931C4.87678 43.4032 8.17084 43.476 10.7155 42.7506C15.335 41.4341 23.7547 33.1602 23.7547 33.1602L23.7603 33.149C24.0371 32.1098 24.1658 31.4488 24.1658 31.4488L24.1685 31.4516Z",
    fill: "url(#paint15_linear_10020_170267)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0281 51.2934C20.6396 62.8444 4.78168 62.9677 4.78168 62.9677C4.78168 62.9677 7.10262 66.1775 10.7071 67.6704C10.5337 67.5052 8.17641 65.2644 8.41969 64.4746C8.66856 63.6595 23.1954 61.7717 25.8687 53.6798L25.8687 53.6742C26.0281 52.2317 26.0281 51.2934 26.0281 51.2934Z",
    fill: "url(#paint16_linear_10020_170267)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4254 68.83C21.0534 69.1129 7.56682 79.1683 -1.71268e-06 76.7959C-1.71268e-06 76.7959 4.20845 81.1849 9.58576 81.2494C9.29215 81.2101 4.58316 80.4987 4.34547 79.0366C4.09381 77.5297 16.7303 74.4543 21.4337 68.8244L21.4226 68.83L21.4254 68.83Z",
    fill: "url(#paint17_linear_10020_170267)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1109 63.0573C24.4118 64.5334 19.8566 74.4935 22.5607 78.7873C24.8285 82.3893 30.5246 82.14 32.9601 81.8459C32.9601 81.8459 27.155 76.7763 25.7149 72.1939C24.7669 69.1885 24.9068 65.3401 25.1109 63.0545L25.1109 63.0573Z",
    fill: "url(#paint18_linear_10020_170267)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4049 22.5475C15.8747 23.9199 24.8676 24.7938 30.1443 22.7687C35.4209 20.7437 36.1815 18.0184 36.1815 18.0184C36.1815 18.0184 30.8294 14.7077 24.9963 16.8392C19.1632 18.9735 15.4049 22.5447 15.4049 22.5447L15.4049 22.5475Z",
    fill: "#9BC672"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.7715 37.3952C37.0176 38.0674 32.1129 34.8408 31.1705 31.4516C30.2281 28.0625 33.2398 26.0682 33.2398 26.0682C33.2398 26.0682 35.2307 33.1686 36.7743 37.3952L36.7715 37.3952Z",
    fill: "#9BC672"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8979 35.3533C21.8979 35.3533 20.8857 42.0755 16.6269 44.0082C12.3681 45.9408 9.93808 43.6973 9.93808 43.6973C9.93808 43.6973 12.5582 42.5349 14.8428 40.6023C17.1274 38.6696 21.8979 35.3505 21.8979 35.3505L21.8979 35.3533Z",
    fill: "#9BC672"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0681 21.9061C32.0681 21.9061 30.8126 21.7128 29.0229 21.9061C27.2333 22.0993 26.0281 24.214 26.0281 24.214C26.0281 24.214 30.2869 23.0152 32.0681 21.9061Z",
    fill: "#83EF72"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.8349 31.0035C30.8349 31.0035 31.9199 30.6198 32.0709 30.1492C32.2219 29.6786 30.2337 28.7403 30.2337 28.7403C30.2337 28.7403 30.4071 30.25 30.8349 31.0007L30.8349 31.0035Z",
    fill: "#83EF72"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3479 41.0084C14.3479 41.0084 15.6705 41.3277 16.8478 40.8011C18.025 40.2746 18.9422 37.4848 18.9422 37.4848C18.9422 37.4848 16.1375 40.0281 14.3479 41.0084Z",
    fill: "#83EF72"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9422 67.1383C16.4647 68.1522 14.3143 65.0376 14.8428 63.8444C15.3741 62.6512 21.6323 60.7213 24.163 57.1641C24.163 57.1641 24.9543 63.5867 18.9422 67.1355L18.9422 67.1383Z",
    fill: "#9BC672"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1416 80.6079C8.76086 81.1093 11.202 77.4597 13.948 75.0397C16.6912 72.6169 20.3264 70.3761 20.3264 70.3761C20.3264 70.3761 18.9982 78.3476 12.1416 80.6079Z",
    fill: "#9BC672"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.334 21.2254C26.5454 24.3933 20.5669 23.9675 19.5658 22.1385C18.5619 20.3095 25.0801 15.6656 27.7758 16.6683C30.4714 17.6739 27.334 21.2226 27.334 21.2226L27.334 21.2254Z",
    fill: "#9BC672"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.0887 10.5007C52.361 13.2652 46.2846 14.0719 42.6829 12.1812C39.0813 10.2906 39.8782 5.15089 40.5689 4.96323C41.2596 4.77557 51.0887 10.5035 51.0887 10.5035L51.0887 10.5007Z",
    fill: "#9BC672"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10020_170267",
    x1: 40.7898,
    y1: 7.45608,
    x2: 61.5552,
    y2: 7.45608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D9138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#429334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#519B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#6AA91C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EAB1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10020_170267",
    x1: 39.8111,
    y1: 9.55677,
    x2: 57.9508,
    y2: 9.55677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCA6A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#CAA0A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C491A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#BB78A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#B464A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10020_170267",
    x1: 22.0154,
    y1: 45.1062,
    x2: 93.7548,
    y2: 45.1062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D9138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#429334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#519B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#6AA91C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EAB1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10020_170267",
    x1: 7.93034,
    y1: 63.6707,
    x2: 30.69,
    y2: 56.9521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D7738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#227A36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#318430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#4B9427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EAB1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10020_170267",
    x1: 21.6658,
    y1: 71.9867,
    x2: 31.6877,
    y2: 69.0295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D7738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#227A36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#318430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#4B9427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EAB1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_10020_170267",
    x1: 3.43387,
    y1: 78.8434,
    x2: 25.3628,
    y2: 72.3733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D7738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#227A36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#318430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#4B9427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EAB1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_10020_170267",
    x1: 3.94281,
    y1: 38.7004,
    x2: 26.9509,
    y2: 38.7004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D9138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#429334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#519B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#6AA91C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EAB1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_10020_170267",
    x1: 14.1997,
    y1: 21.105,
    x2: 43.533,
    y2: 21.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D9138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#429334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#519B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#6AA91C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EAB1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_10020_170267",
    x1: 30.5693,
    y1: 29.9223,
    x2: 43.5778,
    y2: 29.9223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D9138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#429334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#519B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#6AA91C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EAB1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_10020_170267",
    x1: 55.4023,
    y1: 20.5283,
    x2: 77.7592,
    y2: 13.9297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D7738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#227A36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#318430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#4B9427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EAB1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_10020_170267",
    x1: 26.3888,
    y1: 43.6973,
    x2: 45.1017,
    y2: 43.6973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D9138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#429334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#519B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#6AA91C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EAB1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_10020_170267",
    x1: 55.8861,
    y1: 20.461,
    x2: 74.8535,
    y2: 20.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCA6A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#CAA0A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C491A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#BB78A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#B464A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_10020_170267",
    x1: 12.8127,
    y1: 21.9061,
    x2: 38.413,
    y2: 21.9061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCA6A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#CAA0A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C491A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#BB78A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#B464A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_10020_170267",
    x1: 29.8087,
    y1: 32.8885,
    x2: 39.3749,
    y2: 32.8885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCA6A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#CAA0A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C491A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#BB78A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#B464A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_10020_170267",
    x1: 25.659,
    y1: 45.8624,
    x2: 41.8608,
    y2: 45.8624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCA6A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#CAA0A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C491A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#BB78A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#B464A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_10020_170267",
    x1: 2.85784,
    y1: 37.3952,
    x2: 22.9549,
    y2: 37.3952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCA6A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#CAA0A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C491A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#BB78A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#B464A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_10020_170267",
    x1: 6.30567,
    y1: 59.4805,
    x2: 24.9068,
    y2: 59.4805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCA6A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#CAA0A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C491A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#BB78A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#B464A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_10020_170267",
    x1: 1.53797,
    y1: 75.0397,
    x2: 20.3012,
    y2: 75.0397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCA6A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#CAA0A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C491A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#BB78A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#B464A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_10020_170267",
    x1: 22.5187,
    y1: 72.5273,
    x2: 32.3673,
    y2: 72.5273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCA6A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#CAA0A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C491A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#BB78A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#B464A5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVineLeft);
export default ForwardRef;